import React from 'react'
import PropTypes from 'prop-types'
import { withPrefix } from 'gatsby'
import * as S from './styled'
import { Download } from '@dasa-health/alma-icons'
import getDocForDownload from '../../utils/getDocForDownload'

 const DownloadButton = ({examId}) =>{

    const docPath = getDocForDownload(examId);

    if (!docPath) return null;

    const docUrl = withPrefix(docPath);

    return (
        <S.CopyButton
                size='sm'
                brand={true}
                onClick={() => window.open(docUrl, "_blank") }
                className="btn-dasa-genomica"
            >
                <S.CopyPasteButton float>
                    <S.CopyIcon>
                    <Download />
                    </S.CopyIcon>
                    <S.Copy>Download</S.Copy>
                </S.CopyPasteButton>
            </S.CopyButton>
    );
}

DownloadButton.propTypes = {
    examId: PropTypes.string,
  }

export default DownloadButton;
